import { render, staticRenderFns } from "./TabProgrammatically.vue?vue&type=template&id=7680889b&"
import script from "./TabProgrammatically.vue?vue&type=script&lang=js&"
export * from "./TabProgrammatically.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports